import { ref, unref } from 'vue'
export interface PaginationParams {
  current: number
  size: number
  [key: string]: any
}
const usePagination = (initialFunc: (param: any) => Promise<any>) => {
  const pagination: PaginationParams = {
    current: 1,
    size: 20
  }
  const dataList = ref<any[]>([])
  const loading = ref<boolean>(false) // 数据加载loading
  const finished = ref<boolean>(false) // 是否完成
  const refreshing = ref<boolean>(false) // 下拉刷新
  const param = ref<PaginationParams>(pagination)
  const func = ref(initialFunc) // 动态 func 的引用
  const fetchPageData = async (tempParam = {}) => {
    param.value = {
      ...{ current: param.value.current, size: param.value.size },
      ...tempParam
    }
    try {
      if (unref(refreshing)) {
        param.value.current = 1
        finished.value = false
      }
      if (unref(finished)) {
        return
      }
      const res = await func.value(param.value)
      if (!res) {
        console.log(res)
        return
      }
      const { code, data } = res || {}
      if (code !== 1) {
        return
      }
      const tempData = data.records || []
      const { total, page, size } = data
      if (total) {
        // param.value.current = page
        // param.value.size = size
        param.value.total = total
      }
      if (param.value.current !== 1) {
        // 如果当前页大于1 合并
        dataList.value = [...dataList.value, ...tempData]
      } else {
        // 否则 赋值
        dataList.value = tempData
      }
      if (unref(dataList).length >= total) {
        // 没有更多了
        finished.value = true
      }
    } catch (err) {
      console.log(err)
    } finally {
      if (unref(refreshing)) {
        // 如果下拉 请求完成后 清楚下拉loading
        refreshing.value = false
      }
      loading.value = false // 拿到数据 清楚请求loading
    }
  }

  const refreshFn = async () => {
    refreshing.value = true
    finished.value = false
    param.value.current = 1
    await fetchPageData(param.value)
  }

  const loadMore = async () => {
    if (refreshing.value) return // 正在刷新，禁止触发 loadMore
    if (!unref(dataList).length || !!unref(finished)) return
    loading.value = true
    console.log('loadMore')
    param.value.current += 1
    await fetchPageData(param.value)
  }

  return {
    param,
    dataList,
    loading,
    finished,
    refreshing,
    fetchPageData,
    refreshFn,
    loadMore,
    setFunc: (newFunc: (param: any) => Promise<any>) => {
      func.value = newFunc // 更新 func 引用
      param.value.current = 1
      finished.value = false
      dataList.value = []
    }
  }
}

export default usePagination
